import { queryOptions } from "@tanstack/react-query";

import { getBlogIndex, getBlogPost } from "./blog.functions";

export const blogIndexQuery = queryOptions({
  queryKey: ["blog", "index"],
  queryFn: () => getBlogIndex(),
  staleTime: 5 * 60 * 1000,
});

export const blogPostQuery = (slug: string) =>
  queryOptions({
    queryKey: ["blog", "post", slug],
    queryFn: () => getBlogPost({ data: { slug } }),
    staleTime: 5 * 60 * 1000,
  });
